import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import React from 'react';
import PropTypes from 'prop-types';
import { INSURANCE_STATUSES } from './constants';
export var CancelEnrollmentRequestMessage = function CancelEnrollmentRequestMessage(_ref) {
  var insuranceStatus = _ref.insuranceStatus,
    planName = _ref.planName,
    client = _ref.client;
  switch (insuranceStatus) {
    case INSURANCE_STATUSES.pending_enrollment:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "You are about to cancel the", /*#__PURE__*/React.createElement("span", {
        className: "font-bold text-red"
      }, " ", planName, " "), "pending enrollment request for ", /*#__PURE__*/React.createElement("b", null, " ", client), ". The client will not be enrolled if you cancel the request."), /*#__PURE__*/React.createElement("p", null, "Are you sure you want to cancel the request?"));
    case INSURANCE_STATUSES.pending_disenrollment:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "You are about to cancel the", /*#__PURE__*/React.createElement("span", {
        className: "font-bold text-red"
      }, " ", planName, " "), "pending disenrollment request for ", /*#__PURE__*/React.createElement("b", null, " ", client), ". The client will remain enrolled if you cancel the request."), /*#__PURE__*/React.createElement("p", null, "Are you sure you want to cancel the request?"));
    default:
      return '';
  }
};
CancelEnrollmentRequestMessage.propTypes = {
  insuranceStatus: PropTypes.oneOf(_Object$keys(INSURANCE_STATUSES)).isRequired,
  planName: PropTypes.string.isRequired,
  client: PropTypes.string.isRequired
};
//# sourceMappingURL=CancelEnrollmentRequestMessage.js.map